import React from 'react'
import AddNewSectionFilter from '../../../../components/forms/fields/AddNewSection/AddNewSectionFilter.jsx';
import { GENRES, PERIOD, ATTRIBUTES } from "../../../../constants/programSectionTypes";

class AddNewSectionFilterContainer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentGenreOption: '',
            currentAttributeOption: '',
            currentPeriodOption: '',
            filterActive: ''
        }

        this.changeOption = this.changeOption.bind(this)
    }

    changeOption(option, id, form, field) {
        if(!option || !id) {
            const optionObject = {}
            form.setFieldValue(field.name, optionObject)

            this.setState({
                currentGenreOption: '',
                currentAttributeOption: '',
                currentPeriodOption: '',
                filterActive: ''
            })

        } else {
            const value = option.value

            form.setFieldValue('filterType', id)
            form.setFieldValue('filterValue', value)
    
            if(id === GENRES) {
                this.setState({
                    currentGenreOption: option,
                    currentAttributeOption: '',
                    currentPeriodOption: '',
                    filterActive: id
                })
            } else if(id === PERIOD) {
                this.setState({
                    currentGenreOption: '',
                    currentAttributeOption: '',
                    currentPeriodOption: option,
                    filterActive: id
                })
            } else if(id === ATTRIBUTES) {
                this.setState({
                    currentGenreOption: '',
                    currentAttributeOption: option,
                    currentPeriodOption: '',
                    filterActive: id
                })
            } else {
                this.setState({
                    currentGenreOption: '',
                    currentAttributeOption: '',
                    currentPeriodOption: '',
                    filterActive: ''
                })
            }
        }
    }

    render() {
        const {currentGenreOption, currentPeriodOption, currentAttributeOption, filterActive} = this.state
        const {genres, values, technicalAttributes} = this.props

        return <AddNewSectionFilter 
            filterActive={filterActive} 
            changeOption={this.changeOption} 
            currentGenreOption={currentGenreOption} 
            currentAttributeOption={currentAttributeOption} 
            currentPeriodOption={currentPeriodOption} 
            technicalAttributes={technicalAttributes} 
            genres={genres} 
            values={values} />
    }
}


export default AddNewSectionFilterContainer